import React, { PureComponent } from 'react'
import { isEmpty } from 'ramda'
import AddButton from 'components/Integration/components/AddButton/index'
import { getDisplayName } from 'shared-web/src/helpers/CustomerHelpers'
import OwnerMappingRow from './OwnerMappingRow'
import withNotifications from 'components/shared/notifications'
import hubspotEmptyUserMappingState from 'images/svg/hubspot-empty-user-mapping.svg'

import './style.styl'

class OwnerMapper extends PureComponent {

  constructor(props) {
    super(props)

    this.state = {
      userMappings: _.cloneDeep(props.mappings) || [],
      pendingInvites: null,
      invitedIndex: null,
      hasActiveSearch: null,
      waitingForInvitedUsers: false
    }
  }

  getFormattedUserOptions = (users) => {
    return Object.values(users).map(user => {
      return { value: user.id, label: getDisplayName(user) }
    })
  }

  componentWillUpdate() {
    const { waitingForInvitedUsers, pendingInvites, invitedIndex } = this.state
    const { driftUsers } = this.props

    if (waitingForInvitedUsers) {
      const pendingUser = Object.values(driftUsers).filter(user=> user.email === pendingInvites[0])
      if (!pendingUser.length) {
        this.props.fetchOrgUsers()
      } else {
        this.saveDriftUserOption({ value: pendingUser[0].id }, invitedIndex)
        this.setState({
          pendingInvites: null,
          invitedIndex: null,
          waitingForInvitedUsers: false,
        })
      }
    }
  }

  isValid = () => {

    const hasInvalidOptions = _.some(this.state.userMappings, ({ integrationUserId, driftUserId }) => {
      return (integrationUserId && !driftUserId) || (!integrationUserId && driftUserId)
    })

    return !this.state.userMappings.length || !hasInvalidOptions
  }

  onMappingsChange = () => {
    const { userMappings } = this.state

    if (this.isValid()) {
      this.saveMappings()
    }

    if (!userMappings.length)
      this.addNewMapping()
  }

  getIntegrationUserOptions = (id) => {
    const mappedIds = this.state.userMappings
      .map(mapping => mapping.integrationUserId)
      .filter(integrationId => integrationId !== id)

    return this.props.integrationUsers
      .filter(user => !mappedIds.includes(user.id))
      .map(user => {
        return { label: user.name, value: user.id }
      })
  }

  searchIntegrationUsers = (query, index) => {
    this.setState({
      hasActiveSearch: query.length ? index : null
    })

    !!query.length && this.debouncedSearch(query)
    return query
  }

  debouncedSearch = _.debounce(query => {
    this.props.searchIntegrationUsers(query)
  }, 500)

  addNewMapping = () => {
    const emptyMap = Object.assign({}, this.props.userMappingModel)

    this.setState(prevState => ({
      userMappings: prevState.userMappings.concat(emptyMap)
    }))
  }

  removeMapping = (index) => {
    const mappings = [...this.state.userMappings]
    mappings.splice(index, 1)

    this.setState(({ 
      userMappings: mappings
    }), this.onMappingsChange)
  }

  saveIntegrationOption = (value, index) => {
    const mappings = [...this.state.userMappings]
    mappings[index].integrationUserId = value ? value.value : null

    this.setState({ userMapping: mappings }, this.onMappingsChange)
  }

  saveDriftUserOption = (value, index) => {
    const mappings = [...this.state.userMappings]
    mappings[index].driftUserId = value ? value.value : null

    this.setState({ userMapping: mappings }, this.onMappingsChange)
  }

  saveMappings() {
    const { patchMappings, notifications, integrationName } = this.props
    const userMappingsWithoutEmptyRows = this.state.userMappings.filter(mapping => !_.isEqual(mapping, this.props.userMappingModel))
    patchMappings({ mappings: userMappingsWithoutEmptyRows }, () => {
      notifications.success(`You've successfully updated your ${integrationName} owner mappings!`)
    })
  }

  renderMappingRows() {
    const { userMappings, hasActiveSearch } = this.state
    const { isSearching, integrationName, driftUsers } = this.props
    const formattedDriftUsers = this.getFormattedUserOptions(driftUsers)

    return userMappings.map((mapping, index) => {
      return (
        <OwnerMappingRow
          integrationName={integrationName}
          key={index}
          index={index}
          mapping={mapping}
          isSearching={isSearching}
          driftUsers={formattedDriftUsers}
          getUserOptions={this.getIntegrationUserOptions}
          searchUsers={this.searchIntegrationUsers}
          saveOption={this.saveIntegrationOption}
          saveUserOption={this.saveDriftUserOption}
          hasActiveSearch={hasActiveSearch}
          onMappingRemove={this.removeMapping}
        />
      )
    })
  }

  render() {
    const { integrationName } = this.props
    const { userMappings } = this.state

    return (
      <div className="integration-user-mapping">
        <table className="drift-table">
          <thead>
            <tr className="integration-user-mapping-header">
              <th>{integrationName} User</th>
              <th className="integration-user-mapping-table-seperator"></th>
              <th>Drift Teammate</th>
              <th className="integration-user-mapping-actions"></th>
            </tr>
          </thead>
          {
            !isEmpty(userMappings)
              ? (
                <tbody>
                  {this.renderMappingRows()}
                </tbody>
              ) : (
                <tbody className="hubspot-user-mapping-empty-state">
                  <tr>
                    <td><img src={hubspotEmptyUserMappingState}/></td>
                  </tr>
                  <tr>
                    <td>
                      <p>You don’t have any users mapped between Drift and Hubspot yet.</p>
                    </td>
                  </tr>
                </tbody>
              )
          }
        </table>
        <AddButton
          addButtonLabel={`Map New ${integrationName} User`}
          type="tertiary"
          onClick={this.addNewMapping}
        />
      </div>
    )
  }

}

export default withNotifications(OwnerMapper)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/components/OwnerMapper/index.js